/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import { FeathersVuex } from '../feathers-client'

Vue.use(Vuex)
Vue.use(FeathersVuex)

const requireModule = require.context(
  // The path where the service modules live
  './services',
  // Whether to look in subfolders
  false,
  // Only include .js files (prevents duplicate imports`)
  /.js$/
)
const servicePlugins = requireModule
  .keys()
  .map(modulePath => requireModule(modulePath).default)


import moduleAuth from './auth/moduleAuth.js'
import auth from './store.auth'
import moduleUserAuth from './user-auth/moduleUserAuth.js'
import moduleAddSkill from './add-skill/moduleAddSkill.js'
import moduleEndorsementInvite from './endorsement-invite/moduleEndorsementInvite.js'
import moduleHome from './home/moduleHome'
import moduleCompetencyProgress from './competency-progress/moduleCompetencyProgress'
import moduleCompanyManagement from './company-management/moduleCompanyManagement'
import moduleUserManagement from './user-management/moduleUserManagement'
import moduleTraineeCoachAssignment from './trainee-coach-assignment/moduleTraineeCoachAssignment'
import moduleCoachingExperience from './coaching-experience/moduleCoachingExperience'
import moduleDevelopmentActions from './development-actions/moduleDevelopmentActions'
import moduleNotesManagement from './usercoach-notes/moduleNotesManagement'
import moduleTodo from './todo/moduleTodo.js'
export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  plugins: [...servicePlugins, auth],
  modules: {
    auth: moduleAuth,
    userAuth: moduleUserAuth,
    userManagement: moduleUserManagement,
    companyManagement: moduleCompanyManagement,
    traineeCoachAssignment: moduleTraineeCoachAssignment,
    home: moduleHome,
    addSkill: moduleAddSkill,
    endorsementInvite: moduleEndorsementInvite,
    competencyProgress: moduleCompetencyProgress,
    coachingExperience: moduleCoachingExperience,
    developmentActions: moduleDevelopmentActions,
    notesManagement: moduleNotesManagement,
    todo: moduleTodo,
  },
  strict: process.env.NODE_ENV !== 'production'
})
